/**
 * Internal dependencies
 */
import { DisclosureMenu } from '../lib/accessible-menu';

const Menu = ( () => {
	function init() {
		document.addEventListener( 'DOMContentLoaded', () => {
			const containerElement = document.querySelector(
				'.wp-block-photobooths-header__menu',
			);
			const menuElement = containerElement.querySelector(
				'.wp-block-photobooths-header__menu-list',
			);
			const navToggle = document.querySelector(
				'.wp-block-photobooths-header__toggle',
			);

			window.megamenuBlocks = new DisclosureMenu( {
				menuElement,
				submenuItemSelector:
					'.wp-block-photobooths-header__menu-list .menu-item-has-children',
				submenuSelector: '.sub-menu',
				containerElement,
				controllerElement: navToggle,
				optionalKeySupport: true,
				openClass: 'is-visible',
				closeClass: 'is-hidden',
				hoverType: 'on',
			} );

			function navigationExpanded( e ) {
				if (
					window.matchMedia( '(max-width: 781px)' ) &&
					e.target.matches( '.wp-block-photobooths-header__toggle' )
				) {
					document.body.classList.add( 'nav-open' );
					document.body.scrollIntoView();
				}
			}
			window.addEventListener( 'accessibleMenuExpand', navigationExpanded );

			function navigationCollapsed( e ) {
				if (
					window.matchMedia( '(max-width: 781px)' ) &&
					e.target.matches( '.wp-block-photobooths-header__toggle' )
				) {
					document.body.classList.remove( 'nav-open' );
				}
			}
			window.addEventListener(
				'accessibleMenuCollapse',
				navigationCollapsed,
			);
		} );

		window.addEventListener( 'resize', () => {
			if ( window.innerWidth > 959 ) {
				document.body.classList.remove( 'nav-open' );
				document.querySelector( '.wp-block-photobooths-header__menu-list' )?.classList.remove( 'is-visible' );
				document.querySelector( '.wp-block-photobooths-header__menu-list' )?.classList.add( 'is-hidden' );
				document.querySelector( '.wp-block-photobooths-header__toggle' )?.setAttribute( 'aria-expanded', 'false' );

				if ( window.megamenuBlocks ) {
					window.megamenuBlocks.blur();
				}
			}
		} );
	}

	return {
		init,
	};
} )();

export default Menu;
